import React from "react";

import { Box } from '@mui/material';
import PageHeader from "./PageHeader";
import PageFooter from "./PageFooter";
import theme_ from "theme/CurrentTheme";


interface Props {
    htmlTitle?: string;
    title?: string;
    description?: string;
    current?: string;

    children: React.ReactNode;
}

export default function PageContents(props: Props) {
    return <Box sx={{
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        p: 0,
        m: 0,
    }}>
        <PageHeader title={props.title} current={props.current} description={props.description}/>

        <Box display='flex' flexDirection='column' alignItems='center' sx={{
            //maxWidth: theme_.pageContentsWidth
        }}>
            {props.children}
        </Box>

        <PageFooter/>
    </Box>
}


